import styled from 'styled-components'
import Paragraph from 'components/typography/paragraph'
import { Points as PointsBase } from 'pages/meetings/components/agenda'
import MetaBase from 'components/meta'

export const Description = styled(Paragraph)`
    font-size: 20px;
    line-height: 28px;

    .modal-header + & {
        margin-top: 16px;
    }
`

export const Points = styled(PointsBase)`
    padding: 0;

    .modal-header + & {
        margin-top: 16px;
    }
`

export const Meta = styled(MetaBase)`
    margin-top: 0;
`